 /* payment/commonview/lib/view-notification.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */
import core from '../../common/lib/core.js';

const elements = {};
let removeListeners = null;
let confirmationCallback = null; //= confirmCallback || function empty() {};
let messageText;
let color; // color classes:
const openGlobalClassname = 'global-notification--is-open';
const openClassname = 'notification-wrap--open';
const closeClassname = 'notification-wrap--close';

// TODO: copied from original notification code. Use when adding autohide.
// TODO; this commented code is kept for a while (oct 14 2016) until autohide is implemented
// function showNotification(message, color, autoHide, customTimer) {
// 	const $notification = $globalNotificationsContainer.find('.notification-wrap');
// 	const notificationColor = (color && $.inArray(color, validColors) >= 0) ? color : 'yellow';
//
// 	$notification.find('.notification-wrap__error-text-msg').text(message);
//
// 	$globalNotificationsContainer.addClass('global-notification--is-open');
// 	$notification.removeClass('notification-wrap--close red green yellow').addClass(`notification-wrap--open ${notificationColor}`);
//
// 	// add click handler to close the notification
// 	$notification.find('.icon-close ').on('click', (event) => {
// 		event.preventDefault();
// 		event.stopPropagation();
// 		hideNotification();
// 	});
//
// 	if (autoHide) {
// 		setTimeout(() => {
// 			hideNotification();
// 		}, (customTimer || timerForMessageAutoHide));
// 	}
// }

function selectElements() {
	elements.wrap = (elements.wrap || document.querySelector('.js-global-notification')); /* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = (elements.wrapSubContent || elements.wrap.querySelector('.js-notification'));
	elements.mainText = (elements.mainText || elements.wrapSubContent.querySelector('.js-text'));
	elements.wrapBtnYes = (elements.wrapBtnYes || elements.wrap.querySelector('.js-button-wrap-yes'));
	elements.btnYes = (elements.btnYes || elements.wrapSubContent.querySelector('button'));
}

function setTexts() {
	elements.mainText.innerHTML = messageText;
}

function openWrappers() {
	core.addClass(elements.wrap, openGlobalClassname);
	core.removeClass(elements.wrapSubContent, closeClassname);
	core.addClass(elements.wrapSubContent, openClassname);
	core.addClass(elements.wrapSubContent, color);
}

function closeWrappers() {
	core.removeClass(elements.wrap, openGlobalClassname);
	core.addClass(elements.wrapSubContent, closeClassname);
	core.removeClass(elements.wrapSubContent, openClassname);
	core.removeClass(elements.wrapSubContent, color);
}

function close() {
	removeListeners();
	closeWrappers();
}

function clickYesHandler() {
	close();
	confirmationCallback();
}

function addListeners() {
	elements.wrapBtnYes.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.wrapBtnYes) {
		elements.wrapBtnYes.removeEventListener('click', clickYesHandler);
	}
};

export default {
	show(p) {
		confirmationCallback = (p.confirmCb || function empty() {});
		messageText = (p.mainTxt || 'The action you requested could not be fulfilled. Try again later or contact customerservice.');
		color = (p.color || 'red'); // alternatively 'neutral'
		selectElements();
		setTexts();
		addListeners();
		openWrappers();
	},
	close() {
		close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-notification.js